import * as React from 'react';
export const usageSvg = React.forwardRef(function usageSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.5a6.5 6.5 0 0 0-5.478 10h10.956A6.5 6.5 0 0 0 8 2.5ZM14.245 14a8 8 0 1 0-12.49 0h12.49Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.578 5.688a.775.775 0 0 1 1.079.02.775.775 0 0 1 .02 1.078l-3.581 3.846a.962.962 0 0 1-1.389.025.962.962 0 0 1 .025-1.389l3.846-3.58Z',
    }),
  );
});
usageSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usage = {
  category: 'icon',
  colorable: true,
  name: 'usage',
  svg: usageSvg,
};
